<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Informations générales</h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-11">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <!-- Name -->
                            <div class="col-12 col-md-12">
                                <label for="name" class="form-label mt-2">Nom<span class="text-purple">*</span></label>
                                <input
                                    type="text"
                                    class="form-control fs-6 py-2"
                                    id="name"
                                    v-model="formData.name"
                                    placeholder="Entrez le nom"
                                />
                                <div v-if="errors.name" class="invalid-feedback">{{ errors.name }}</div>
                            </div>

                            <!-- Description -->
                            <div class="col-12 col-md-12">
                                <label class="form-label" for="description">Description</label>
                                <div ref="editor" class="editor-container"></div>
                                <div v-if="errors.description" class="invalid-feedback">{{ errors.description }}</div>
                            </div>

                            <!-- Description générale -->
                            <div class="col-12 col-md-12">
                                <label class="form-label" for="general_description">Description générale</label>
                                <div ref="generalEditor" class="editor-container"></div>
                                <div v-if="errors.general_description" class="invalid-feedback">
                                    {{ errors.general_description }}
                                </div>
                            </div>

                            <!-- Visibility Toggle -->
                            <div class="col-12 col-md-12 mt-4">
                                <div
                                    class="form-check form-switch form-check-inline w-100 rounded-12 px-3 d-flex align-items-center"
                                >
                                    <BaseSwitch
                                        id="is_visible"
                                        v-model="formData.is_visible"
                                        label-left="Visible en ligne"
                                        :error="errors.is_visible"
                                    />
                                </div>
                            </div>

                            <!-- Image Upload -->
                            <div class="col-12 mt-2">
                                <label class="form-label pb-2" for="image">Illustration de l'activité</label>
                                <div
                                    class="form-control overflow-hidden text-center new-image"
                                    style="cursor: pointer; padding-top: 33px"
                                >
                                    <input type="file" id="image-input" hidden @change="handleImageUpload" accept="image/*" />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="29"
                                        height="24"
                                        viewBox="0 0 29 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M9.99988 15L13.9999 11L17.9999 15"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M13.9999 11V23"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>

                                    <label for="image-input" class="form-control text-center" style="cursor: pointer"
                                        >Télécharger image</label
                                    >
                                    <img
                                        v-if="imagePreview"
                                        :src="imagePreview"
                                        class="border-0 rounded-12"
                                        style="width: 360px"
                                    />
                                    <div v-if="errors.image" class="invalid-feedback">{{ errors.image }}</div>
                                </div>
                            </div>

                            <div class="row mt-4 justify-content-center py-1 not-option">
                                <div class="col-11">
                                    <div class="block-header">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-3">
                                            List de(s) activité(s)
                                        </h3>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="select_activites" class="form-label">Choisir de(s) activité(s)</label>
                                            <v-select
                                                class="v-select"
                                                id="select_activites_"
                                                v-model="formData.selected_activites"
                                                :options="filteredPrestations"
                                                label="name"
                                                hide-selected
                                                multiple
                                                :get-option-label="(option) => option.name"
                                                placeholder="Choisir de(s) activité(s)"
                                                aria-label="Sélectionnez de(s) activité(s)"
                                            >
                                                <template #option="{ name }">
                                                    {{ name }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4 justify-content-center py-1 not-option">
                                <div class="col-11">
                                    <div class="block-header">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-3">FAQ</h3>
                                    </div>

                                    <div class="row justify-content-center py-3">
                                        <div class="col-12 mb-4 position-relative">
                                            <span
                                                id="aiButton"
                                                class="btn btn-primary-ai"
                                                @click="showTooltip"
                                                :disabled="isLoading"
                                            >
                                                <img class="ai_image" src="/media/svg/ai-white.png" alt="Ai_logo" />
                                                <span id="button-text">{{ buttonReqAiText }}</span>
                                                <span
                                                    class="spinner-border spinner-border-sm text-primary"
                                                    role="status"
                                                    aria-hidden="true"
                                                    v-if="isLoading"
                                                ></span>
                                            </span>

                                            <div v-if="showAiPrompt" class="tooltip pt-3" @mouseleave="hideTooltip">
                                                <span class="mb-2 p-1 float-end btn_close_foodMD" @click="hideTooltip">
                                                    <i class="fa fa-times"></i>
                                                </span>

                                                <textarea
                                                    class="form-control"
                                                    rows="4"
                                                    v-model="promptFaq"
                                                    placeholder="Écrivez votre sujet ici..."
                                                >
                                                </textarea>

                                                <button
                                                    class="btn btn-primary mt-2"
                                                    type="button"
                                                    :disabled="isLoading || !promptFaq != ''"
                                                    @click="handleButtonClick"
                                                >
                                                    {{ buttonSendText }}
                                                    <span
                                                        class="spinner-border spinner-border-sm text-primary"
                                                        role="status"
                                                        aria-hidden="true"
                                                        v-if="isLoading"
                                                    ></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <faq-component
                                        :faqs="faqs"
                                        @add-faq="addFAQ"
                                        @remove-faq="removeFAQ"
                                        @move-up="moveUp"
                                        @move-down="moveDown"
                                    />
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mt-4 pt-2 gap-40 flex-wrap mx-6">
                                <a
                                    href="/back-office/package"
                                    class="btn btn-outline-dark line_height41 rounded-12 fw-semibold width-btn height_btn_page"
                                >
                                    Annuler
                                </a>
                                <button type="submit" class="btn btn-dark rounded-12 fw-semibold width-btn height_btn_page">
                                    {{ this.data.id ? 'Mettre à jour' : 'Ajouter' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import BaseSwitch from '../Shared/BaseSwitch.vue'
import 'vue-select/dist/vue-select.css'

export default {
    props: ['data', 'tags', 'packages', 'package_categories'],
    data() {
        return {
            formData: {
                name: '',
                description: '',
                general_description: '',
                is_visible: true,
                image: null,
                selected_activites: [],
            },
            imagePreview: null,
            faqs: [],
            buttonReqAiText: "Demander l'aide par l'IA",
            buttonSendText: 'Envoyer',
            isLoading: false,
            promptFaq: '',
            showAiPrompt: false,
            errors: {},
            editorInstance: null,
            editor: ClassicEditor,

            descriptionEditorInstance: null,
            generalDescriptionEditorInstance: null,
        }
    },

    computed: {
        filteredPrestations() {
            // Ensure selected_activites is an array
            const selectedActivities = Array.isArray(this.formData.selected_activites) ? this.formData.selected_activites : []

            // Create a lookup for selected activity IDs using reduce
            const selectedIds = selectedActivities.reduce((acc, selected) => {
                acc[selected.id] = true
                return acc
            }, {})

            // Filter out already selected prestations
            return this.packages.filter((option) => !selectedIds[option.id])
        },
    },

    methods: {
        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.formData.image = e.target.result
                    this.imagePreview = URL.createObjectURL(file)
                }
                reader.readAsDataURL(file)
            }
        },

        handleSubmit() {
            this.errors = {}
            if (this.formData.id) {
                this.update()
            } else {
                this.store()
            }
        },

        async store() {
            this.formData.faqs = this.faqs
            this.formData.description = this.descriptionEditorInstance.getData()
            this.formData.general_description = this.generalDescriptionEditorInstance.getData()

            axios
                .post('/back-office/tags/store-v2', this.formData)
                .then((response) => {
                    this.$toast.success(this.$t('tags.create_success'))
                    setTimeout(() => {
                        window.location.href = '/back-office/tags'
                    }, 2000)
                })
                .catch((error) => {
                    console.error('Error creating package:', error)
                    this.showErrors(error.response)
                })
        },

        async update() {
            const _id = this.data.id
            this.formData.faqs = this.faqs
            this.formData.description = this.descriptionEditorInstance.getData()
            this.formData.general_description = this.generalDescriptionEditorInstance.getData()

            axios
                .put(`/back-office/tag/${_id}/edit`, this.formData)
                .then((response) => {
                    this.$toast.success('Le tag a été mis à jour avec succès !')
                })
                .catch((error) => {
                    console.error('Error updating tag:', error)
                    this.showErrors(error.response)
                })
        },

        showErrors(response) {
            this.errors = {}
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors
                for (const key in errors) {
                    let errorMessage = errors[key][0]
                    this.$set(this.errors, key, errorMessage)
                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },

        addFAQ(question = '', answer = '') {
            this.faqs.push({ question: question, answer: answer })
        },

        removeFAQ(index) {
            this.faqs.splice(index, 1)
        },

        moveUp(index) {
            console.log('moveUp', index)
            if (index > 0) {
                const temp = this.faqs[index]
                this.faqs[index] = this.faqs[index - 1]
                this.faqs[index - 1] = temp
            }
        },

        moveDown(index) {
            if (index < this.faqs.length - 1) {
                const temp = this.faqs[index]
                this.faqs[index] = this.faqs[index + 1]
                this.faqs[index + 1] = temp
            }
        },

        async handleButtonClick() {
            this.isLoading = true
            this.buttonReqAiText = 'Chargement des données...'
            this.buttonSendText = 'Chargement des données...'

            try {
                const response = await axios.post(`/chat-research-faq`, {
                    type: 'website_faq',
                    text: this.promptFaq,
                    number: 7,
                })
                response?.data?.data?.data?.faq.forEach((item) => {
                    this.addFAQ(item.question, item.answer)
                })
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoading = false
                this.hideTooltip()
                this.buttonReqAiText = "Demander l'aide par l'IA"
                this.buttonSendText = 'Envoyer'
            }
        },

        showTooltip() {
            this.showAiPrompt = true
        },

        hideTooltip() {
            this.showAiPrompt = false
        },

        initializeEditor(ref, modelKey) {
            const editorConfig = {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    '|',
                    'link',
                    'blockQuote',
                    '|',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'insertTable',
                    'imageUpload',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'alignment:left',
                    'alignment:center',
                    'alignment:right',
                    'alignment:justify',
                    '|',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'highlight',
                    'removeFormat',
                ],
                language: 'fr',
                placeholder: `Tapez votre ${modelKey === 'description' ? 'description' : 'description générale'} ici...`,
            }

            ClassicEditor.create(this.$refs[ref], editorConfig)
                .then((editor) => {
                    // Save editor instance
                    this[`${modelKey}EditorInstance`] = editor

                    // Set initial data
                    editor.setData(this.formData[modelKey] || '')

                    // Update `formData` on change
                    editor.model.document.on('change:data', () => {
                        const data = editor.getData()
                        if (data !== this.formData[modelKey]) {
                            this.formData[modelKey] = data
                        }
                    })
                })
                .catch((error) => {
                    console.error(`Error initializing CKEditor for ${modelKey}:`, error)
                })
        },
    },

    mounted() {
        /**
         * update case
         */
        if (Object.keys(this.data).length !== 0) {
            this.formData = {
                ...this.formData, // Keep existing keys like selected_activites
                ...this.data, // Overwrite with incoming data
            }

            this.faqs = this.data?.faqs || []

            if (this.prestation_tag) {
                this.prestation_tag.map((item) => {
                    this.formData.selected_activites.push({
                        id: item.id,
                        name: item.name,
                    })
                })
            }
        }

        this.imagePreview = this.formData?.image ?? null

        if (this.editor && this.$refs.editor) {
            this.editor.create(this.$refs.editor).then((instance) => {
                this.descriptionEditorInstance = instance
                instance.setData(this.formData.description)
            })
        }

        if (this.editor && this.$refs.generalEditor) {
            this.editor.create(this.$refs.generalEditor).then((instance) => {
                this.generalDescriptionEditorInstance = instance
                instance.setData(this.formData.general_description)
            })
        }
    },

    components: {
        vSelect,
        BaseSwitch,
    },
}
</script>

<style scoped>
.invalid-feedback {
    color: #dc3545;
    font-size: 0.875em;
    margin-top: 0.25em;
    display: block;
    line-height: 1.25;
}

.is-invalid {
    border-color: #dc3545;
    background-color: #f8d7da;
    color: #721c24;
}

.is-invalid ~ .invalid-feedback {
    display: block;
}

.new-image {
    background: #f8fafc;
    padding: 33px 0 8px;
}
</style>
